import { Theme } from '@mui/material';

const Snackbar = (theme: Theme) => {
  return {
  };
};

export default Snackbar;
